// extracted by mini-css-extract-plugin
module.exports = {"table-filter-section":"table-filter-section__2bfcR","label":"label__wBRFr","body":"body__3l9pK"};